import { render, staticRenderFns } from "./PreferencesTab.vue?vue&type=template&id=c1eca198"
import script from "./PreferencesTab.vue?vue&type=script&lang=js"
export * from "./PreferencesTab.vue?vue&type=script&lang=js"
import style0 from "./PreferencesTab.vue?vue&type=style&index=0&id=c1eca198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports